import { FC } from 'react';
import threeDSecurePromptClass from '../../assets/scss/SubscriptionList/ThreeDSecurePrompt.module.scss';

export const ThreeDSecurePrompt: FC<{ nextActionUrl: string }> = ({ nextActionUrl }) => {
  return (
    <div className={threeDSecurePromptClass.container}>
      <div className={threeDSecurePromptClass.text}>決済の本人認証が必要です</div>
      <a
        className={threeDSecurePromptClass.btn}
        href={nextActionUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        認証ページに進む
      </a>
    </div>
  );
};
